/**
 * Drawing abbreviations — the firm list (Supabase `drawing_abbreviations`, database/292,
 * api/drawing-abbreviations.js). The AlderCAD G003 sheet prints it (docs/bim-plan/28 round 7);
 * Templates -> Abbreviations edits it. bim/annotation/abbreviations.js holds the seed fallback.
 */

async function post(payload) {
  const headers = { 'Content-Type': 'application/json' }
  if (typeof window !== 'undefined' && typeof window.__clerkGetToken !== 'function') {
    for (let i = 0; i < 40 && typeof window.__clerkGetToken !== 'function'; i++) {
      await new Promise((r) => setTimeout(r, 250))
    }
  }
  if (typeof window !== 'undefined' && typeof window.__clerkGetToken === 'function') {
    try { const t = await window.__clerkGetToken(); if (t) headers['Authorization'] = 'Bearer ' + t } catch { /* unauthed */ }
  }
  const res = await fetch('/api/drawing-abbreviations', { method: 'POST', headers, body: JSON.stringify(payload) })
  const data = await res.json().catch(() => ({ error: 'Bad response from /api/drawing-abbreviations' }))
  if (!res.ok || data.error) throw new Error(data.error || ('Request failed (' + res.status + ')'))
  return data
}

/** every row in the firm's order: `{ id, abbr, meaning, active }` */
export async function listDrawingAbbreviations() {
  const { rows } = await post({ action: 'list' })
  return (rows || []).map((r) => ({ id: r.id, abbr: r.abbr, meaning: r.meaning, active: r.active !== false }))
}

/** change one row's letters, meaning and/or whether it prints */
export async function saveDrawingAbbreviation(id, { abbr, meaning, active }, byName) {
  const { row } = await post({ action: 'save', id, abbr, meaning, active, byName })
  return row
}

export async function addDrawingAbbreviation(abbr, meaning, byName) {
  const { row } = await post({ action: 'add', abbr, meaning, byName })
  return { id: row.id, abbr: row.abbr, meaning: row.meaning, active: row.active !== false }
}

export async function removeDrawingAbbreviation(id) {
  await post({ action: 'remove', id })
}
